//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Images from '../../modules/images.js';
// import animation from '../../modules/animation.js';
// import scroll from '../../modules/scroll.js';
import Parallax from '../../modules/parallax.js';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: "Blog",
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      title: '',
      posts: [],
      filters: {
        categories: {
          terms: [],
          current: 'all',
          placeholder: 'All Topics',
        },
      },
      latest: false,
      searching: false,
      noResults: false,
      loadmore: false,
      distance: -Infinity,
      reset: false,
      page: 1,
      hasPagination: false,
      pagination: false,
      isLoadingNextPage: false,
    }
  },
  mounted() {

    wp.api.loadPromise.done( () => {
      this.loadArchive();
    });

  },
  watch: {

    categories: 'buildPosts',

  },
  methods: {

    loadArchive() {

      const postData = {};
      const termData = {};

      this.buildPosts( postData );
      this.buildTerms( termData );

    },
    filter() {

      this.searching = true;

      this.page = 1;
      this.posts = [];
      this.infiniteId += 1;

      const currentFilters = this.filters.categories.current;
      const postData = {
        filters: {
          'category': currentFilters,
        },
      };

      setTimeout( () => {
        this.buildPosts( postData );
      }, 500 );

    },
    loadMoreTrigger() {

      this.isLoadingNextPage = true;

      this.distance = 100;
      this.$nextTick(() => {
        this.$refs.infiniteLoading.attemptLoad();
      });

    },
    loadMoreHandler( $state ) {

      if ( this.distance < 0 || this.distance != parseInt( this.distance, 10 ) ) {
        return;
      }

      const data = {};
      data.page = this.page + 1;
      data.paged = this.page + 1;

      const allPosts = new wp.api.collections.Posts();

      allPosts.fetch({ data }).done( ( results ) => {

        this.pagination = results.pagination;

        if ( results.results && results.results.length ) {
          this.page += 1;
          this.posts.push( ...results.results );

          if ( this.page >= results.pagination.query.total || results.pagination.query.current == results.pagination.query.total ) {
            this.pagination = false;
            this.hasPagination = false;
          } else {
            this.hasPagination = true;
          }

          $state.loaded();
          this.distance = -Infinity;
          this.isLoadingNextPage = false;

        } else {

          $state.complete();

        }

      });

    },
    buildPosts( data ) {

      const allPosts = new wp.api.collections.Posts();
      // console.log( data );

      allPosts.fetch({ data }).done( ( results ) => {

        console.log( results );
        this.searching = false;
        this.title = results.title;

        if ( !results ) {
          this.noResults = results.no_results;
          return;
        }

        if ( ( typeof results.results == 'undefined' || Object.keys( results.results ).size == 0 ) ) {
          this.noResults = results.no_results;
          this.hasPagination = false;
          return;
        } else {
          this.noResults = false;
        }

        if ( results.pagination.query.total > 1 ) {
          this.hasPagination = true;
        }

        this.posts = results.results;
        this.pagination = results.pagination;

        if ( results.pagination.query.current == results.pagination.query.total ) {
          this.hasPagination = false;
        } else {
          this.hasPagination = true;
        }

        setTimeout( () => {
          Parallax.designParallax();
          // Images.lazyload.update();
        }, 200)

      })

    },
    buildTerms( data ) {

      const allTerms = new wp.api.collections.Categories();

      allTerms.fetch({ data }).done( ( results ) => {
        this.filters.categories.terms = results;
      });

    },
  },
}




// WEBPACK FOOTER //
// ./scripts/vue/Blog/Blog.vue